/* eslint-disable max-len */
import {conditionType} from '../../../../../pages/esgManager/interface/inputType';
import {FieldConditions} from '../../../interface/form-conditions';
import {
  createRowMultiSelectField,
  createRowNumberField,
  createRowSelectField,
  createRowWysiwygField,
  createTableQuestion,
  createTableWithFixedRowsQuestion
} from '../../../Utils/questionHelper';

import {
  DURABLE_GOODS_SOLD_USED_OPTIONS,
  END_OF_LIFE_MANAGEMENT_PATHWAY_OPTIONS,
  PACKAGING_RECYCLABILITY_OPTIONS,
  PLASTIC_CONTENT_TYPE_OPTIONS,
  PLASTIC_PACKAGE_SOLD_USED_OPTIONS,
  PLASTIC_RELATED_ACTIVITIES_OPTIONS,
  PLASTICS_TARGET_TYPE_OPTIONS_FULL,
  YES_NO_OPTIONS,
  YES_NO_WITH_PLAN_OPTIONS
} from './corporateOptions';
import {CDP_PLASTICS_KEYS} from './corporateQuestionsKeys';

export const environmentalPerformancePlasticsQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q1_VALUE,
        '10.1 Do you have plastics-related targets, and if so what type?',
        'Organizations need to set and progress targets that address their plastics-related dependencies, impacts, risks, and opportunities. This question allows organizations to demonstrate to data users their commitment to reduce plastic usage, reduce or eliminate virgin content in plastics, eliminate problematic and unnecessary plastics, transition to reuse systems, reduce microplastic emissions, and increase circularity.',
        [
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q1_1_VALUE,
            'Targets in place',
            YES_NO_WITH_PLAN_OPTIONS
          ),
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q1_2_VALUE,
            'Target type and metric',
            PLASTICS_TARGET_TYPE_OPTIONS_FULL,
            true,
            {
              fieldName: CDP_PLASTICS_KEYS.Q1_1_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            }
          ),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q1_3_VALUE,
            'Please explain',
            5000
          )
        ]
      )
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q2_VALUE,
        '10.2 Indicate whether your organization engages in the following activities.',
        'Different activities related to the production, commercialization, and use of plastics may result in different dependencies, impacts, risks, and opportunities. This question enables data users to contextualize the information you provide in this module.',
        [
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q2_1_VALUE,
            'Activity',
            PLASTIC_RELATED_ACTIVITIES_OPTIONS
          ),
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q2_2_VALUE,
            'Activity applies',
            YES_NO_OPTIONS
          ),
          createRowWysiwygField(CDP_PLASTICS_KEYS.Q2_3_VALUE, 'Comment', 2000)
        ],
        false,

        CDP_PLASTICS_KEYS.Q1_VALUE,
        CDP_PLASTICS_KEYS.Q1_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q3_VALUE,
        '10.3 Provide the total weight of plastic polymers sold and indicate the raw material content.',
        'Organizations monitoring the types and amounts of raw materials they use to produce plastic polymers are better able to understand their plastics-related dependencies, impacts, risks, and opportunities, and thus take action to increase the circularity of plastics sold.',
        [
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q3_1_VALUE,
            'Total weight of plastic polymers sold during the reporting year (Metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_PLASTICS_KEYS.Q3_2_VALUE,
            'Raw material content percentages available to report',
            PLASTIC_CONTENT_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q3_3_VALUE,
            '% virgin fossil-based content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q3_4_VALUE,
            '% virgin renewable content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q3_5_VALUE,
            '% pre-consumer recycled content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q3_6_VALUE,
            '% post-consumer recycled content',
            2
          ),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q3_7_VALUE,
            'Please explain',
            1000
          )
        ],
        false,

        CDP_PLASTICS_KEYS.Q2_VALUE,
        CDP_PLASTICS_KEYS.Q2_2_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q4_VALUE,
        '10.4 Provide the total weight of plastic durable goods and durable components produced, sold and/or used, and indicate the raw material content.',
        'Organizations monitoring the amounts and contents of plastic durable goods and durable components they sell and/or use are better able to understand their plastics-related dependencies, impacts, risks, and opportunities, and increase their potential to reduce the use of virgin fossil-based content.',
        [
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q4_1_VALUE,
            'Activity',
            DURABLE_GOODS_SOLD_USED_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q4_2_VALUE,
            'Total weight during the reporting year (Metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_PLASTICS_KEYS.Q4_3_VALUE,
            'Raw material content percentages available to report',
            PLASTIC_CONTENT_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q4_4_VALUE,
            '% virgin fossil-based content',
            2,
            true,
            {
              fieldName: CDP_PLASTICS_KEYS.Q4_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['None']
            }
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q4_5_VALUE,
            '% virgin renewable content',
            2,
            true,
            {
              fieldName: CDP_PLASTICS_KEYS.Q4_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['None']
            }
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q4_6_VALUE,
            '% pre-consumer recycled content',
            2,
            true,
            {
              fieldName: CDP_PLASTICS_KEYS.Q4_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['None']
            }
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q4_7_VALUE,
            '% post-consumer recycled content',
            2,
            true,
            {
              fieldName: CDP_PLASTICS_KEYS.Q4_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['None']
            }
          ),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q4_8_VALUE,
            'Please explain',
            1000
          )
        ],
        false,
        undefined,
        undefined,
        undefined,
        {
          dependsOn: [
            CDP_PLASTICS_KEYS.Q2_1_VALUE,
            CDP_PLASTICS_KEYS.Q2_2_VALUE
          ],
          shouldShow: {
            expression: {
              and: [
                {
                  parentField: CDP_PLASTICS_KEYS.Q2_VALUE,
                  field: CDP_PLASTICS_KEYS.Q2_2_VALUE,
                  operator: 'equals',
                  value: 'Yes'
                },
                {
                  parentField: CDP_PLASTICS_KEYS.Q2_VALUE,
                  field: CDP_PLASTICS_KEYS.Q2_1_VALUE,
                  operator: 'in',
                  value: [
                    'Production/commercialization of durable plastic goods and/or components (including mixed materials)',
                    'Usage of durable plastic goods and/or components (including mixed materials)'
                  ]
                }
              ]
            }
          }
        } satisfies FieldConditions
      )
    ]
  },
  {
    key: 'Q5',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q5_VALUE,
        '10.5 Provide the total weight of plastic packaging sold and/or used and indicate the raw material content.',
        'Organizations monitoring the amounts and contents of plastic packaging that they use or sell are better able to understand their plastics-related dependencies, impacts, risks, and opportunities, and increase their potential to reduce the use of virgin fossil-based content.',
        [
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q5_1_VALUE,
            'Activity',
            PLASTIC_PACKAGE_SOLD_USED_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q5_2_VALUE,
            'Total weight during the reporting year (Metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_PLASTICS_KEYS.Q5_3_VALUE,
            'Raw material content percentages available to report',
            PLASTIC_CONTENT_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q5_4_VALUE,
            '% virgin fossil-based content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q5_5_VALUE,
            '% virgin renewable content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q5_6_VALUE,
            '% pre-consumer recycled content',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q5_7_VALUE,
            '% post-consumer recycled content',
            2
          ),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q5_8_VALUE,
            'Please explain',
            1000
          )
        ],
        false,

        CDP_PLASTICS_KEYS.Q2_VALUE,
        CDP_PLASTICS_KEYS.Q2_1_VALUE,
        [
          'Production/commercialization of plastic packaging',
          'Production/commercialization of goods/products packaged in plastics',
          'Provision/commercialization of services that use plastic packaging (e.g., food services)'
        ]
      )
    ]
  },
  {
    key: 'Q6',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_PLASTICS_KEYS.Q6_VALUE,
        '10.5.1 Indicate the circularity potential of the plastic packaging you sold and/or used.',
        'Companies that monitor reusability and recyclability of their plastic packaging demonstrate a commitment to increasing the share of their packaging that has circularity potential and to tackling the plastic pollution crisis.',
        [
          createRowSelectField(
            CDP_PLASTICS_KEYS.Q6_1_VALUE,
            'Activity',
            PLASTIC_PACKAGE_SOLD_USED_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_PLASTICS_KEYS.Q6_2_VALUE,
            'Percentages available to report for circularity potential',
            PACKAGING_RECYCLABILITY_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q6_3_VALUE,
            '% of plastic packaging that is reusable',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q6_4_VALUE,
            '% of plastic packaging that is technically recyclable',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q6_5_VALUE,
            '% of plastic packaging that is recyclable in practice at scale',
            2
          ),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q6_6_VALUE,
            'Please explain',
            1000
          )
        ],
        false,

        CDP_PLASTICS_KEYS.Q2_VALUE,
        CDP_PLASTICS_KEYS.Q2_1_VALUE,
        [
          'Production/commercialization of plastic packaging',
          'Production/commercialization of goods/products packaged in plastics',
          'Provision/commercialization of services that use plastic packaging (e.g., food services)'
        ]
      )
    ]
  },
  {
    key: 'Q7',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_PLASTICS_KEYS.Q7_VALUE,
        '10.6 Provide the total weight of waste generated by the plastic you produce, commercialize, use and/or process and indicate the end-of-life management pathways.',
        'For organizations that produce, commercialize, use, and/or process plastics, a crucial step in tackling plastics pollution is to understand their end-of-life management of plastics. This question allows organizations to indicate the amount of plastic waste that their organization generates, and how it is managed to drive progress in line with the waste hierarchy.',
        'Activity',
        [
          {id: 'Production of plastic*', label: 'Production of plastic*'},
          {
            id: 'Commercialization of plastic*',
            label: 'Commercialization of plastic*'
          },
          {id: 'Usage of plastic*', label: 'Usage of plastic*'},
          {
            id: 'Processing of plastic waste*',
            label: 'Processing of plastic waste*'
          }
        ],
        [
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_1_VALUE,
            'Total weight of waste generated during the reporting year (Metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_PLASTICS_KEYS.Q7_2_VALUE,
            'End-of-life management pathways available to report',
            END_OF_LIFE_MANAGEMENT_PATHWAY_OPTIONS
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_3_VALUE,
            '% prepared for reuse',
            2
          ),
          createRowNumberField(CDP_PLASTICS_KEYS.Q7_4_VALUE, '% recycling', 2),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_5_VALUE,
            '% composting (industrial/home)',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_6_VALUE,
            '% waste to energy',
            2
          ),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_7_VALUE,
            '% incineration',
            2
          ),
          createRowNumberField(CDP_PLASTICS_KEYS.Q7_8_VALUE, '% landfill', 2),
          createRowNumberField(
            CDP_PLASTICS_KEYS.Q7_9_VALUE,
            '% mismanaged waste',
            2
          ),
          createRowNumberField(CDP_PLASTICS_KEYS.Q7_10_VALUE, '% leakage', 2),
          createRowNumberField(CDP_PLASTICS_KEYS.Q7_11_VALUE, '% other', 2),
          createRowWysiwygField(
            CDP_PLASTICS_KEYS.Q7_12_VALUE,
            'Please explain',
            1000
          )
        ]
      )
    ]
  }
];
